import vRibbon from "./v-ribbon.vue";

export default Vue => {
  Vue.component("v-ribbon", vRibbon);
};
